// extracted by mini-css-extract-plugin
module.exports = {"NewPasswordPage":"NewPasswordPage_NewPasswordPage__19Co1","main":"NewPasswordPage_main__11mD0"};